import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import {breakpoints} from "@next/themes"

interface TileTitleProps {
    $singleLineTitle: boolean
}

const TileTitle = styled(Typography, {shouldForwardProp: prop => !String(prop).startsWith("$")})<TileTitleProps>`
    height: 1.5em;
    overflow: hidden;
    font-family: ${({theme}) => theme.colours.typography.body1.fontFamily};
    letter-spacing: ${({theme}) => theme.colours.typography.body1.letterSpacing};
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    text-transform: capitalize;
    text-decoration: none;
    ${({$singleLineTitle}) =>
        !$singleLineTitle &&
        `
    height: 3em;
    white-space: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    margin-bottom: 0.25rem;

    &:after {
        position: relative;
        content: "";
        border-bottom: 0.0625rem solid #d1d1d1;
        width: 1rem;
        margin: auto;
        display: block;
        bottom: -0.8rem;
    }
    `};
    @media (max-width: ${breakpoints.values.lg - 0.02}px) {
        height: 3em;
        white-space: normal;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        margin-bottom: 0.25rem;

        &:after {
            position: relative;
            content: "";
            border-bottom: 0.0625rem solid #d1d1d1;
            width: 1rem;
            margin: auto;
            display: block;
            bottom: -0.8rem;
        }
    }
`

TileTitle.displayName = "StandardTileTitle"

export default TileTitle
